import { render, staticRenderFns } from "./Rococo.vue?vue&type=template&id=c46a237a&scoped=true&"
import script from "./Rococo.vue?vue&type=script&lang=js&"
export * from "./Rococo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c46a237a",
  null
  
)

export default component.exports